import React from 'react';
import classNames from 'classnames';

const Title = props => {
  const { prefixCls, className, width, style } = props;
  return <h3 className={classNames(prefixCls, className)} style={{ width, ...style }} />;
};
export default Title;



// WEBPACK FOOTER //
// ./src/skeleton/Title.jsx